module.exports = __webpack_public_path__ + "img/avatar4.7b50c192.png";